import { CustomSvgIcon } from "../../modules/common/components/CustomSvgIcon";

export const Chevron = () => {
  return (
    <CustomSvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M6 8L10 12L14 8" stroke="white" strokeWidth="2" />
    </CustomSvgIcon>
  );
};
